<template>
    <div class="bouncing-loader">
        <div class="bouncing-loader__item"></div>
        <div class="bouncing-loader__item"></div>
        <div class="bouncing-loader__item"></div>
        <div class="bouncing-loader__item"></div>
        <div class="bouncing-loader__item"></div>
    </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables.scss';
.bouncing-loader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: mrem(123);
    height: mrem(90);

    @include on-desktop {
        width: rem(246);
        height: rem(90);
    }

    &__item {
        background: $color-main-primary;
        width: mrem(15);
        height: mrem(15);
        border-radius: 50%;

        @include on-desktop {
            width: rem(30);
            height: rem(30);
        }

        animation-iteration-count: infinite;
        animation-duration: 4s;
        position: relative;
        animation-timing-function: ease-in-out;

        @for $i from 1 through 5 {
            &:nth-child(#{$i}) {
                animation-name: bouncingMobile#{$i};
            }

            @keyframes bouncingMobile#{$i} {
                0% {
                    top: 0;
                }

                #{$i * 12.5%} {
                    top: 0;
                }

                #{($i + 1) * 12.5%} {
                    top: mrem(-15);
                }

                #{($i + 2) * 12.5%} {
                    top: mrem(15);
                }

                #{($i + 3) * 12.5%} {
                    top: 0;
                }

                100% {
                    top: 0;
                }
            }
        }

        @include on-desktop {
            @for $i from 1 through 5 {
                &:nth-child(#{$i}) {
                    animation-name: bouncingDesktop#{$i};
                }

                @keyframes bouncingDesktop#{$i} {
                    0% {
                        top: 0;
                    }

                    #{$i * 12.5%} {
                        top: 0;
                    }

                    #{($i + 1) * 12.5%} {
                        @if $i % 2 == 0 {
                            top: rem(-15);
                        } @else {
                            top: rem(-25);
                        }
                    }

                    #{($i + 2) * 12.5%} {
                        top: rem(15);
                    }

                    #{($i + 3) * 12.5%} {
                        top: 0;
                    }

                    100% {
                        top: 0;
                    }
                }
            }
        }
    }
}
</style>
